export const getImageAspectRatio = (width: number, height: number, fallback = 9 / 16) =>
  width > 0 && height > 0 ? width / height : fallback;
